import React from 'react';
import { RakutenKoboLogo } from '@next-common/shared-svg';
import { Label } from '../Label';
export const EbookKoboLabel = () => (React.createElement(Label, { icon: "Ebook", backgroundColor: "red100", textColor: "red800", fontWeight: 400, letterSpacing: "normal" },
    React.createElement(RakutenKoboLogo, null)));
